import { Component, OnInit, ViewChild } from '@angular/core';
import { AuthorizationPipe } from '../../../common/pipes/authorization.pipe';
import { DepartmentInfoTab } from '../../models/department-info-tab-model';
import { MessageService } from '../../../shared/services/message.service';
import { TabsetComponent } from 'ngx-bootstrap';
import { TabConstants } from '../../constants/tab.constants';
import { CommonService } from '../../../shared/services/common.service';
import { AccessLevel } from '../../../common/enums/access-level.enum';
import { Permission } from '../../../common/enums/permission.enum';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'admin',
    templateUrl: '../../templates/template1/views/admin/admin.component.html',
    styleUrls: ['../../templates/template1/themes/default/css/admin.component.less'],
    providers: [AuthorizationPipe]
})
export class AdminComponent implements OnInit {

    enableOrderStatusChangeConfiguration:boolean=environment.enableOrderStatusChangeConfiguration;
    japanDataUploadPermission: any[] = [Permission.CREATE_JAPAN_DATA, Permission.VIEW_JAPAN_DATA, Permission.EDIT_JAPAN_DATA];

    activeTab: number;
    departmentTabs: DepartmentInfoTab[] = [];
    allowJapanAccessMenu: boolean;
    @ViewChild('adminTabs') adminTabs: TabsetComponent;

    constructor(private messageService: MessageService,private _commonService: CommonService) { }

    ngOnInit() {
        this.activeTab = 1;
        this.subscribeDeptTabContent();
        this.allowJapanAccessMenu = this._commonService.checkPermissionByAccessLevel
            (JSON.parse('[' + this.japanDataUploadPermission[0] + ']'), AccessLevel.Customer_Service);
    }
    selectTab(tab: number) {
        this.activeTab = tab;
    }

 /**
     * To add new tab immediately (to reflect in ui - used observable)
     */
    subscribeDeptTabContent() {
        this.messageService.getDepartmentTabContent().subscribe((data: DepartmentInfoTab) => {
            if (data) {
                this.activeTab = 0;
                if (this.departmentTabs.find((tab: DepartmentInfoTab) => tab.departmentID === data.departmentID)) {
                    this.departmentTabs.forEach((tab: DepartmentInfoTab) => {
                        if (tab.departmentID === data.departmentID) { tab.active = true; }
                        else { tab.active = false; }
                    });
                } else {
                    this.departmentTabs.forEach((tab: DepartmentInfoTab) => { tab.active = false; })
                    this.departmentTabs.push(data);
                    this.alignTabs();
                }
            }
        });
    }
    removeDept(tab: DepartmentInfoTab): void {
        if (this.departmentTabs) {
            this.departmentTabs.splice(this.departmentTabs.indexOf(tab), 1);
            this.alignTabs();
            const tabIndex = this.adminTabs.tabs.findIndex(item => item.id === TabConstants.DEPARTMENT);
            this.adminTabs.tabs[tabIndex].active = true;
            this.activeTab = 1;
        }
    }

    /**
     * @description
     * @date 2020-03-05
     * @memberof AdminComponent
     */
    alignTabs(): void {
        setTimeout(() => {
            const element: any = document.querySelector('.cs-primary-tabs.nav > .nav-tabs');
            const tabContentElement: any = document.querySelector('.cs-primary-tabs.nav > .tab-content');
            if (element && tabContentElement) {
                const tabsHeight = element.offsetHeight;
                tabContentElement.style.marginTop = (tabsHeight - 10) + 'px';
            }
        }, 100);
    }
}



// WEBPACK FOOTER //
// ./src/app/customerservice/components/admin/admin.component.ts